import React from 'react';
import JsonView from 'react18-json-view';

/**
 * Response 响应渲染器
 */
function ResponseRenderer({ response }) {
  return (
    <div className="ocr-code__pre">
      <JsonView
        src={response}
        keyName={false}
        theme="default"
        displayDataTypes={false}
      />
    </div>
  );
}

export default ResponseRenderer;
